module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing_1_ES-fcee00abc8dc703462a5ff679fff266d.svg";